module.exports = __webpack_public_path__ + "img/MiFi-T115.a57756c5.jpg";